<a (click)="handleClick()" tappable>
  <span *ngIf="label">{{ label | translate }}</span>
  <ng-content></ng-content>
</a>
